import * as THREE from 'three'
import Experience from '../../Experience.js'
import Debug from '../../Utils/Debug.js'
import Properties from "../../Properties.js";
import Resources from "@experience/Utils/Resources.js";
import * as helpers from "@experience/Utils/HelpersFunctions.js";
import Model from "./Abstracts/Model.js";

export default class RespiratorySystem extends Model {
    experience = new Experience()
    debug = new Debug()
    properties = new Properties()
    scene = experience.scene
    time = experience.time
    camera = experience.camera.instance
    renderer = experience.renderer.instance
    resources = experience.resources
    cursor = experience.cursor
    timeline = experience.timeline;

    loadingModel = false;

    sources = [ {
        name: 'respiratorySystemModel',
        type: 'gltfModel',
        path: 'models/respiratory_system/respiratory_system.gltf'
    } ]
    sourcesReady = 'RespiratorySystemReady'

    container = new THREE.Group();

    constructor( body ) {
        super()
        this.body = body

        // this.setModel()
        // this.setDebug()
    }

    setModel() {
        this.respiratorySystemModel = this.resources.items.respiratorySystemModel.scene

        helpers.meshToBatchedMesh( this.respiratorySystemModel, this.container, this.body.batchedMeshesIds )

        //this.body.changeVisibility( this.respiratorySystemModel, false )

        //this.container.add( this.respiratorySystemModel );
        //helpers.cloneAllMaterials( this.container );
        this.body.container.add( this.container );
    }

    resize() {

    }

    setDebug() {
        if ( !this.debug.active ) return
    }

    update( deltaTime ) {

    }

}
